<div>
  <ul class="list-unstyled step-progress">
    <li [class.step-submitted]="IsSubmittedStatus()" 
        [class.step-approved]="IsApproved()" 
        [class.active]="IsStep1Active()"
        [ngbTooltip]="submittedLabel"
        placement="top-left">
            <i  class="fas"
              [class.fa-inbox]="IsSubmittedStatus()" 
              [class.fa-check]="IsApproved()" 
              [class.fa-minus]="IsCancelled()" 
              aria-hidden="true"></i>
    </li>
    <li class="step-followup" 
        [class.active]="CheckStatus(RequestUserStatus.FollowupSubmitted)" 
        [class.expiring]="CheckStatus(RequestUserStatus.FollowupExpiring)" 
        [class.expired]="CheckStatus(RequestUserStatus.FollowUpExpired)"   
        [class.waiting]="CheckStatus(RequestUserStatus.FollowUpRequired)"
        [class.step-approved]="CheckStatus(RequestUserStatus.FollowUpApproved)"
        [class.forgiven]="CheckStatus(RequestUserStatus.FollowupForgiven)"
        [ngbTooltip]="followUpLabel">
      <i [ngClass]="getFollowupIcon()" aria-hidden="true"></i></li>
    <li class="step-completed" 
        [class.disapproved]="CheckStatus(RequestUserStatus.Disapproved)" 
        [class.active]="CheckStatus(RequestUserStatus.Completed)" 
        [ngbTooltip]="completedLabel">
        <i class="fas"
          [class.fa-check]="!IsCancelled() && !IsDisapproved()" 
          [class.fa-minus]="IsCancelled()" 
          [class.fa-times]="IsDisapproved()" 
          aria-hidden="true"></i></li>
  </ul>
</div>